import { MasterHelper } from '../../utilities';
import { AdditionalFilter } from '../rulebook/additional-filter';

export class SelfAssessmentFilter extends AdditionalFilter {
    fromDate: string=""; 
    toDate: string=MasterHelper.getDateStr(0);
    ruleBook: string[];
    part: string[];
    owner: string[];
    regulatoryRuleFullRequirement:string[];
    assessmentTeam: string[];
    assessmentDetails: string[];
    assessmentStatus: string[];
    reviewTeam: string[];
    reviewDetails: string[];
    reviewStatus: string[];
    overallStatus: string[];
    ruleConclusion: string[];
    overallConclusion: string[];
    gapTeam: string[];
    gapDetails: string[];
    gapStatus: string[];
    enhancementTeam: string[];
    enhancementDetails: string[];
    enhancementStatus: string[];
    searchQuery: string[];

    constructor() {
        super();
        this.fromDate = "";
        this.toDate = MasterHelper.getDateStr(0);
        this.ruleBook = [];
        this.part = [];
        this.owner = [];
        this.regulatoryRuleFullRequirement = [];
        this.assessmentTeam = [];
        this.assessmentDetails = [];
        this.assessmentStatus = [];
        this.reviewTeam = [];
        this.reviewDetails = [];
        this.reviewStatus = [];
        this.overallStatus = [];
        this.ruleConclusion = [];
        this.overallConclusion = [];
        this.gapTeam = [];
        this.gapDetails = [];
        this.gapStatus = [];
        this.enhancementTeam = [];
        this.enhancementDetails = [];
        this.enhancementStatus = [];
        this.searchQuery = [];
    }
}
